/**
 * Minimal toast shim for the Import Hub.
 *
 * The extracted Import Hub doesn't ship a toast UI — it just emits
 * notifications. Host apps can plug in their own toast library
 * (sonner, react-hot-toast, radix, etc.) via `setToastHandler`.
 *
 * Default behavior: log to the console so nothing crashes if the host
 * never wires a handler.
 */

export type ToastLevel = "success" | "error" | "warning" | "info";
export type ToastHandler = (level: ToastLevel, message: string) => void;

const defaultHandler: ToastHandler = (level, message) => {
  const fn =
    level === "error" ? console.error :
    level === "warning" ? console.warn :
    console.log;
  fn(`[toast:${level}] ${message}`);
};

let handler: ToastHandler = defaultHandler;

export function setToastHandler(fn: ToastHandler | null): void {
  handler = fn ?? defaultHandler;
}

export const toast = {
  success: (msg: string) => handler("success", msg),
  error: (msg: string) => handler("error", msg),
  warning: (msg: string) => handler("warning", msg),
  info: (msg: string) => handler("info", msg),
};
